import { Button } from "@material-ui/core";
import React from "react";
import buttonStyles from "./Buttons.module.css";

type GreenButtonProps = {
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  style?: React.CSSProperties;
  children?: React.ReactNode;
};

const GreenButton: React.FC<GreenButtonProps> = ({ onClick, disabled, style, children }) => (
  <Button
    style={style}
    disabled={disabled}
    onClick={onClick}
    className={buttonStyles.ButtonGreen}
  >
    {children}
  </Button>
);

export default GreenButton;
